import { apiClient } from './client';

export interface AuthStatus {
  authRequired: boolean;
}

export interface LoginResponse {
  token?: string;
  authRequired?: boolean;
}

export const authApi = {
  async getStatus(): Promise<AuthStatus> {
    const { data } = await apiClient.get<AuthStatus>('/api/auth/status');
    return data;
  },

  async login(password: string): Promise<LoginResponse> {
    const { data } = await apiClient.post<LoginResponse>('/api/auth/login', { password });
    return data;
  },
};
